module.exports = __webpack_public_path__ + "img/dashboard.50c2ed58.svg";